import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from 'utils/api';

export const fetchQualificationList = createAsyncThunk(
  'qualification/fetchQualificationList',
  async ({ page, pageSize, search }: { page: number; pageSize: number; search: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean, data: any }>('get', `/auth/qualification/search/?page=${page}&page_size=${pageSize}&search=${search}`);
      const payload = response.data.data;
      if (payload && payload.results) {
        return { results: payload.results, count: payload.count };
      }
      return { results: payload || [], count: payload?.length || 0 };
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch qualification list');
    }
  }
);
